/* istanbul ignore file */
// layout
import { Show } from 'framework/show';
import { SectionRow, ShowSection, BigSectionRow } from 'framework/ui/layout';
import { SensitiveShowPageLayout } from 'framework/sensitiveData';
// fields
import { ReplaceUrlWithLink } from 'framework/utils';
import { AttachmentsListField } from 'domain/shared/artifact/field';
import { TextField, DateField, HtmlField, CapitalizedField } from 'framework/ui/field';
import FinanceProbationReductionField from 'domain/people/employee/finance/shared/fields/FinanceProbationReductionField';
// buttons
import EditFinanceButton from 'domain/people/employee/finance/shared/buttons/EditFinanceButton';
import DeleteFinanceButton from 'domain/people/employee/finance/shared/buttons/DeleteFinanceButton';
// services
import useFinanceService, {
  FINANCE_READ_EMPLOYEE_COMPENSATION_PACKAGE,
} from 'domain/people/employee/finance/shared/financeService';
import { useFinanceId, useFinanceUrl } from 'domain/people/employee/finance/financeRouting';
import { EmployeeOfficeField } from 'domain/shared/employee';
import { useNavigate } from 'react-router-dom';
import { Button } from 'framework/ui/mui-builder';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

const ViewFinance = () => {
  const navigate = useNavigate();

  const financeId = useFinanceId();
  const { getById } = useFinanceService();
  const { getListUrl } = useFinanceUrl();

  return (
    <SensitiveShowPageLayout
      toggleSensitiveDataButtonProps={{ size: 'small' }}
      buttons={[
        <EditFinanceButton
          size="small"
          source={financeId}
          key="edit-finance"
          icon={<i className="fa fa-edit" />}
          permissionToCheck={FINANCE_READ_EMPLOYEE_COMPENSATION_PACKAGE}
        />,
        <DeleteFinanceButton
          size="small"
          key="delete-finance"
          permissionToCheck={FINANCE_READ_EMPLOYEE_COMPENSATION_PACKAGE}
        />,
      ]}
      timerId={getListUrl()}
    >
      <Show isSmallLoader getDataMethod={() => getById(financeId)}>
        <ShowSection
          titleVariant="h4"
          title="View: Compensation package"
          titleStartAdornment={
            <Button onClick={() => navigate(getListUrl())} sx={{ mr: 1, minWidth: 'auto', p: 0.2 }} variant="outlined">
              <NavigateBeforeIcon />
            </Button>
          }
        >
          <SectionRow>
            <CapitalizedField source="type" label="Compensation package type" />
            <DateField source="effectiveDateFrom" label="Effective from" />
            <DateField
              source="effectiveDateTo"
              label="Effective to (including)"
              isVisible={(data: any) => data.getValueBySource('effectiveDateTo')}
            />
            <CapitalizedField source="baseAmountType" label="Base amount type" />
            <TextField source="grossAmount" label="Base amount gross" />
            <TextField source="currency" label="Currency" />
            <FinanceProbationReductionField
              source="grossProbationAmount"
              probationAmountSource="grossProbationAmount"
              baseAmountSource="grossAmount"
              label="Probation period reduction"
              isVisible={(data: any) => data.getValueBySource('grossProbationAmount')}
            />
            <TextField
              source="grossProbationAmount"
              label="Probation period absolute value gross"
              isVisible={(data: any) => data.getValueBySource('grossProbationAmount')}
            />
            <DateField source="firstDay" label="First day of base value application" />
            <EmployeeOfficeField source="officeId" label="Office" />
          </SectionRow>
          <BigSectionRow>
            <ReplaceUrlWithLink isVisible={data => data.getValueBySource('additionalExpenses')}>
              <HtmlField
                source="additionalExpenses"
                label="Additional expenses compensated"
                isVisible={(data: any) => data.getValueBySource('additionalExpenses')}
              />
            </ReplaceUrlWithLink>
          </BigSectionRow>
          <BigSectionRow>
            <AttachmentsListField
              source="scansIds"
              label=""
              isVisible={data => data.getValueBySource('scansIds')?.length}
            />
          </BigSectionRow>
        </ShowSection>
      </Show>
    </SensitiveShowPageLayout>
  );
};

export default ViewFinance;
